import gql from "graphql-tag"

export default gql`
  mutation subtitleImportOpenSubtitles($mediaId: String!, $fileId: String!, $language: String!) {
    subtitle: subtitleImportOpenSubtitles(mediaId: $mediaId, fileId: $fileId, language: $language) {
      id
      language
      offset
    }
  }
`
